import { getTranslation } from "../locales/getTranslation";
import { useAppContext } from "../hooks/useAppContext";
import { Brand } from "../context/AppProvider";

interface WarningProps {
  onOpenPrivacy?: () => void;
}

const Warning = ({ onOpenPrivacy }: WarningProps) => {
  const { brand, locale } = useAppContext();

  return (
    <p
      className="hidden text-center text-[11px] font-normal leading-[15px] text-grayscale-solid-g9 md:block lg:text-xs"
      onClick={(e) => {
        if (
          (e.target as HTMLElement).classList.contains(
            "privacy-notice-trigger",
          )
        ) {
          onOpenPrivacy?.();
        }
      }}
      dangerouslySetInnerHTML={{
        __html:
          (brand === Brand.CLOSET
            ? getTranslation(locale, "Chatbot Warning CLO-SET")
            : getTranslation(locale, "Chatbot Warning CLO3D")) || "",
      }}
    ></p>
  );
};

export default Warning;
